import React from 'react'

import { faSms } from '@fortawesome/free-solid-svg-icons'

import Card from '../utils/Card'
import { ButtonLink } from '../utils/Button'

import { Header2 } from '../utils/Header'

const SmsOverLimit = () => {
  // const isAuthenticated = useSelector((store) => store.session.isAuthenticated);

  return (
    <Card color="orange">
      <Header2 small icon={faSms}>SMS Limits Reached!</Header2>
      <div className="prose-lg">
        <p>SMS alerting on your account is currently disabled.</p>
        <p>

        </p>
      </div>

      <div className="mt-8">
        <ButtonLink to="/premium/sms" color="gray" className="text-2xl">
          Add SMS Capacity
        </ButtonLink>
      </div>
    </Card>
  )
}

export default SmsOverLimit
